import { SelfAssessmentFilter } from 'src/app/core/models/self-assessment/self-assessment-filter';
import { SelfAssessmentMasterFilter } from './../../../core/models/self-assessment/self-assessment-master-filter';
import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Output,
  EventEmitter,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { FilterViewModel } from 'src/app/core/models/regulation';
import { MasterHelper } from 'src/app/core/utilities';
import { GDPRService } from 'src/app/core/services/rulebook';
import {
  MatAutocomplete,
  MatAutocompleteSelectedEvent,
} from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-self-assessment-filter',
  templateUrl: './self-assessment-filter.component.html',
  styleUrls: ['./self-assessment-filter.component.scss'],
})
export class SelfAssessmentFilterComponent implements OnInit {
  @Output() OnFilter = new EventEmitter<SelfAssessmentFilter>();
  @ViewChild('autoKeyword') autoKeyword!: MatAutocomplete;
  @ViewChild('keywordInput') keywordInput!: ElementRef<HTMLInputElement>;

  filterPersistenceKey = 'selfAssessmentFilters';
  selfAssessmentFilter: SelfAssessmentFilter;
  masterFilters: SelfAssessmentMasterFilter;

  searchedKey: FilterViewModel[] = [];
  searchedRuleBook: FilterViewModel[] = [];
  searchedPart: FilterViewModel[] = [];
  searchedOwner: FilterViewModel[] = [];
  searchedRegRule: FilterViewModel[] = [];
  searchedAT: FilterViewModel[] = [];
  searchedAD: FilterViewModel[] = [];
  searchedAS: FilterViewModel[] = [];
  searchedRT: FilterViewModel[] = [];
  searchedRD: FilterViewModel[] = [];
  searchedRS: FilterViewModel[] = [];
  searchedOS: FilterViewModel[] = [];
  searchedRC: FilterViewModel[] = [];
  searchedOC: FilterViewModel[] = [];
  searchedGT: FilterViewModel[] = [];
  searchedGD: FilterViewModel[] = [];
  searchedGS: FilterViewModel[] = [];
  searchedET: FilterViewModel[] = [];
  searchedED: FilterViewModel[] = [];
  searchedES: FilterViewModel[] = [];

  separatorKeysCodes: number[] = [ENTER, COMMA];
  isLoadingFilters = false;
  searchRBCntrl: FormControl = new FormControl();
  searchPACntrl: FormControl = new FormControl();
  searchOWCntrl: FormControl = new FormControl();
  searchRRCntrl: FormControl = new FormControl();
  searchATCntrl: FormControl = new FormControl();
  searchADCntrl: FormControl = new FormControl();
  searchASCntrl: FormControl = new FormControl();
  searchRTCntrl: FormControl = new FormControl();
  searchRDCntrl: FormControl = new FormControl();
  searchRSCntrl: FormControl = new FormControl();
  searchOSCntrl: FormControl = new FormControl();
  searchRCCntrl: FormControl = new FormControl();
  searchOCCntrl: FormControl = new FormControl();
  searchGTCntrl: FormControl = new FormControl();
  searchGDCntrl: FormControl = new FormControl();
  searchGSCntrl: FormControl = new FormControl();
  searchETCntrl: FormControl = new FormControl();
  searchEDCntrl: FormControl = new FormControl();
  searchESCntrl: FormControl = new FormControl();
  keyCtrl = new FormControl();
  filteredKeywords: string[];

  //RuleBook
  @ViewChild('rBInput')
  rBInput!: ElementRef<HTMLInputElement>;
  @ViewChild('rBAutocomplete')
  rBAutocomplete!: MatAutocomplete;

  //Part
  @ViewChild('pAInput')
  pAInput!: ElementRef<HTMLInputElement>;
  @ViewChild('pAAutocomplete')
  pAAutocomplete!: MatAutocomplete;

  //Owner
  @ViewChild('oWInput')
  oWInput!: ElementRef<HTMLInputElement>;
  @ViewChild('oWAutocomplete')
  oWAutocomplete!: MatAutocomplete;

  //Rule Regulation
  @ViewChild('rRInput')
  rRInput!: ElementRef<HTMLInputElement>;
  @ViewChild('rRAutocomplete')
  rRAutocomplete!: MatAutocomplete;

  //Assessment Team
  @ViewChild('aTInput')
  aTInput!: ElementRef<HTMLInputElement>;
  @ViewChild('aTAutocomplete')
  aTAutocomplete!: MatAutocomplete;

  //Assessment Details
  @ViewChild('aDInput')
  aDInput!: ElementRef<HTMLInputElement>;
  @ViewChild('aDAutocomplete')
  aDAutocomplete!: MatAutocomplete;

  //Assessment Status
  @ViewChild('aSInput')
  aSInput!: ElementRef<HTMLInputElement>;
  @ViewChild('aSAutocomplete')
  aSAutocomplete!: MatAutocomplete;

  //Review Team
  @ViewChild('rTInput')
  rTInput!: ElementRef<HTMLInputElement>;
  @ViewChild('rTAutocomplete')
  rTAutocomplete!: MatAutocomplete;

  //Review Details
  @ViewChild('rDInput')
  rDInput!: ElementRef<HTMLInputElement>;
  @ViewChild('rDAutocomplete')
  rDAutocomplete!: MatAutocomplete;

  //Review Status
  @ViewChild('rSInput')
  rSInput!: ElementRef<HTMLInputElement>;
  @ViewChild('rSAutocomplete')
  rSAutocomplete!: MatAutocomplete;

  //Overall Status
  @ViewChild('oSInput')
  oSInput!: ElementRef<HTMLInputElement>;
  @ViewChild('oSAutocomplete')
  oSAutocomplete!: MatAutocomplete;

  //Rule Conclusion
  @ViewChild('rCInput')
  rCInput!: ElementRef<HTMLInputElement>;
  @ViewChild('rCAutocomplete')
  rCAutocomplete!: MatAutocomplete;

  //Overall Conclusion
  @ViewChild('oCInput')
  oCInput!: ElementRef<HTMLInputElement>;
  @ViewChild('oCAutocomplete')
  oCAutocomplete!: MatAutocomplete;

  //Gap Team
  @ViewChild('gTInput')
  gTInput!: ElementRef<HTMLInputElement>;
  @ViewChild('gTAutocomplete')
  gTAutocomplete!: MatAutocomplete;

  //Gap Details
  @ViewChild('gDInput')
  gDInput!: ElementRef<HTMLInputElement>;
  @ViewChild('gDAutocomplete')
  gDAutocomplete!: MatAutocomplete;

  //Gap Status
  @ViewChild('gSInput')
  gSInput!: ElementRef<HTMLInputElement>;
  @ViewChild('gSAutocomplete')
  gSAutocomplete!: MatAutocomplete;

  //Enhancement Team
  @ViewChild('eTInput')
  eTInput!: ElementRef<HTMLInputElement>;
  @ViewChild('eTAutocomplete')
  eTAutocomplete!: MatAutocomplete;

  //Enhancement Details
  @ViewChild('eDInput')
  eDInput!: ElementRef<HTMLInputElement>;
  @ViewChild('eDAutocomplete')
  eDAutocomplete!: MatAutocomplete;

  //Enhancement Status
  @ViewChild('eSInput')
  eSInput!: ElementRef<HTMLInputElement>;
  @ViewChild('eSAutocomplete')
  eSAutocomplete!: MatAutocomplete;
  resetDone = false;

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  oldestCreationDate: string = MasterHelper.getDateStr(30);
  isPersistFilter = false;
  templateNo = 1;
  divisionId!: number;

  constructor(private gdprService: GDPRService, private datePipe: DatePipe) {
    this.selfAssessmentFilter = new SelfAssessmentFilter();
    this.masterFilters = new SelfAssessmentMasterFilter();
    this.selfAssessmentFilter.fromDate = '';
    this.selfAssessmentFilter.toDate = '';
    // this.masterFilters.fromDate = null;
    // this.masterFilters.toDate = null;
    this.selfAssessmentFilter = MasterHelper.parseSelfAssessmentFilters(
      this.selfAssessmentFilter
    ) as SelfAssessmentFilter;
    const persistFilter = JSON.parse(
      this.fetchFromBrowser(this.filterPersistenceKey) as string
    ) as SelfAssessmentFilter;
    if (persistFilter) {
      this.selfAssessmentFilter = persistFilter;
      this.isPersistFilter = true;
    }
    this.filteredKeywords = [];
  }

  ngOnInit(): void {
    this.divisionId = JSON.parse(this.fetchFromBrowser("selectedDivision") as string);
    this.gdprService.getSelfAssessmentTemplate(this.divisionId).subscribe((templateNo: number) => {
      this.templateNo = templateNo;
    });
    if (!this.isPersistFilter) {
      this.initFilters();
    }
    // this.initFilters();
    this.getMasterFilters();
  }

  initFilters(): void {
    this.selfAssessmentFilter = new SelfAssessmentFilter();
    if(this.templateNo == 2){
      this.gdprService.getOldestDateT2().subscribe((res: string) => {
        if (res) {
          this.selfAssessmentFilter.fromDate = res;
          this.oldestCreationDate = res;
        }
      });
    }
    else{
      this.gdprService.getOldestDate().subscribe((res: string) => {
        if (res) {
          this.selfAssessmentFilter.fromDate = res;
          this.oldestCreationDate = res;
        }
      });
    }
    
    this.selfAssessmentFilter.ruleBook = [];
    this.selfAssessmentFilter.part = [];
    this.selfAssessmentFilter.owner = [];
    this.selfAssessmentFilter.regulatoryRuleFullRequirement = [];
    this.selfAssessmentFilter.assessmentTeam = [];
    this.selfAssessmentFilter.assessmentDetails = [];
    this.selfAssessmentFilter.assessmentStatus = [];
    this.selfAssessmentFilter.reviewTeam = [];
    this.selfAssessmentFilter.reviewDetails = [];
    this.selfAssessmentFilter.reviewStatus = [];
    this.selfAssessmentFilter.overallStatus = [];
    this.selfAssessmentFilter.ruleConclusion = [];
    this.selfAssessmentFilter.overallConclusion = [];
    this.selfAssessmentFilter.gapTeam = [];
    this.selfAssessmentFilter.gapDetails = [];
    this.selfAssessmentFilter.gapStatus = [];
    this.selfAssessmentFilter.enhancementTeam = [];
    this.selfAssessmentFilter.enhancementDetails = [];
    this.selfAssessmentFilter.enhancementStatus = [];
    this.selfAssessmentFilter.searchQuery = [];

    // this.selfAssessmentFilter.fromDate = this.masterFilters.fromDate;
    // this.selfAssessmentFilter.toDate = this.masterFilters.toDate;

    // this.searchedRuleBook = this.masterFilters.ruleBook;
    // this.searchedPart = this.masterFilters.part;
    this.searchedOwner = this.masterFilters.owner;
    // this.searchedRegRule = this.masterFilters.regulatoryRuleFullRequirement;
    this.searchedAT = this.masterFilters.assessmentTeam;
    // this.searchedAD = this.masterFilters.assessmentDetails;
    this.searchedAS = this.masterFilters.assessmentStatus;
    this.searchedRT = this.masterFilters.reviewTeam;
    // this.searchedRD = this.masterFilters.reviewDetails;
    this.searchedRS = this.masterFilters.reviewStatus;
    this.searchedOS = this.masterFilters.overallStatus;
    this.searchedRC = this.masterFilters.ruleConclusion;
    // this.searchedOC = this.masterFilters.overallConclusion;
    this.searchedGT = this.masterFilters.gapTeam;
    // this.searchedGD = this.masterFilters.gapDetails;
    this.searchedGS = this.masterFilters.gapStatus;
    this.searchedET = this.masterFilters.enhancementTeam;
    // this.searchedED = this.masterFilters.enhancementDetails;
    this.searchedES = this.masterFilters.enhancementStatus;
    // this.searchedKey = this.masterFilters.searchQuery;
    // this.saveOnBrowser(
    //   this.filterPersistenceKey,
    //   JSON.stringify(this.selfAssessmentFilter)
    // );
    // this.OnFilter.emit(this.selfAssessmentFilter);
  }

  resetFilters(): void {
    this.selfAssessmentFilter = new SelfAssessmentFilter();
    if(this.templateNo == 2){
      this.gdprService.getOldestDateT2().subscribe((res: string) => {
        if (res) {
          this.selfAssessmentFilter.fromDate = res;
          const parts = this.selfAssessmentFilter.fromDate.split("T");
          const datePart = parts[0];
          this.selfAssessmentFilter.fromDate = datePart;
          this.oldestCreationDate = res;
        }
      });
    }
    else{
      this.gdprService.getOldestDate().subscribe((res: string) => {
        if (res) {
          this.selfAssessmentFilter.fromDate = res;
          const parts = this.selfAssessmentFilter.fromDate.split("T");
          const datePart = parts[0];
          this.selfAssessmentFilter.fromDate = datePart;
          this.oldestCreationDate = res;
        }
      });
    }
    this.selfAssessmentFilter.ruleBook = [];
    this.selfAssessmentFilter.part = [];
    this.selfAssessmentFilter.owner = [];
    this.selfAssessmentFilter.regulatoryRuleFullRequirement = [];
    this.selfAssessmentFilter.assessmentTeam = [];
    this.selfAssessmentFilter.assessmentDetails = [];
    this.selfAssessmentFilter.assessmentStatus = [];
    this.selfAssessmentFilter.reviewTeam = [];
    this.selfAssessmentFilter.reviewDetails = [];
    this.selfAssessmentFilter.reviewStatus = [];
    this.selfAssessmentFilter.overallStatus = [];
    this.selfAssessmentFilter.ruleConclusion = [];
    this.selfAssessmentFilter.overallConclusion = [];
    this.selfAssessmentFilter.gapTeam = [];
    this.selfAssessmentFilter.gapDetails = [];
    this.selfAssessmentFilter.gapStatus = [];
    this.selfAssessmentFilter.enhancementTeam = [];
    this.selfAssessmentFilter.enhancementDetails = [];
    this.selfAssessmentFilter.enhancementStatus = [];
    this.selfAssessmentFilter.searchQuery = [];

    // this.selfAssessmentFilter.fromDate = this.masterFilters.fromDate;
    // this.selfAssessmentFilter.toDate = this.masterFilters.toDate;

    // this.searchedRuleBook = this.masterFilters.ruleBook;
    // this.searchedPart = this.masterFilters.part;
    this.searchedOwner = this.masterFilters.owner;
    // this.searchedRegRule = this.masterFilters.regulatoryRuleFullRequirement;
    this.searchedAT = this.masterFilters.assessmentTeam;
    // this.searchedAD = this.masterFilters.assessmentDetails;
    this.searchedAS = this.masterFilters.assessmentStatus;
    this.searchedRT = this.masterFilters.reviewTeam;
    // this.searchedRD = this.masterFilters.reviewDetails;
    this.searchedRS = this.masterFilters.reviewStatus;
    this.searchedOS = this.masterFilters.overallStatus;
    this.searchedRC = this.masterFilters.ruleConclusion;
    // this.searchedOC = this.masterFilters.overallConclusion;
    this.searchedGT = this.masterFilters.gapTeam;
    // this.searchedGD = this.masterFilters.gapDetails;
    this.searchedGS = this.masterFilters.gapStatus;
    this.searchedET = this.masterFilters.enhancementTeam;
    // this.searchedED = this.masterFilters.enhancementDetails;
    this.searchedES = this.masterFilters.enhancementStatus;
    this.selfAssessmentFilter.fromDate = this.datePipe.transform(this.selfAssessmentFilter.fromDate, "yyyy-MM-dd")!;
    this.selfAssessmentFilter.toDate = this.datePipe.transform(this.selfAssessmentFilter.toDate, "yyyy-MM-dd")!;
    this.selfAssessmentFilter = MasterHelper.parseSelfAssessmentFilters(
      this.selfAssessmentFilter
    ) as SelfAssessmentFilter;
    this.saveOnBrowser(
      this.filterPersistenceKey,
      JSON.stringify(this.selfAssessmentFilter)
    );
    this.OnFilter.emit(this.selfAssessmentFilter);
  }

  getMasterFilters(): void {
    this.isLoadingFilters = true;
    this.gdprService
      .getSelfAssessmentMasterFilters()
      .subscribe((result: SelfAssessmentMasterFilter) => {
        this.masterFilters = result;
        // this.selfAssessmentFilter.fromDate =
        //   this.masterFilters.fromDate;
        // this.selfAssessmentFilter.toDate = this.masterFilters.toDate;
        this.searchedOwner = this.masterFilters.owner;
        this.searchedAT = this.masterFilters.assessmentTeam;
        this.searchedAS = this.masterFilters.assessmentStatus;
        this.searchedRT = this.masterFilters.reviewTeam;
        this.searchedRS = this.masterFilters.reviewStatus;
        this.searchedOS = this.masterFilters.overallStatus;
        this.searchedRC = this.masterFilters.ruleConclusion;
        this.searchedGT = this.masterFilters.gapTeam;
        this.searchedGS = this.masterFilters.gapStatus;
        this.searchedET = this.masterFilters.enhancementTeam;
        this.searchedES = this.masterFilters.enhancementStatus;
        this.isLoadingFilters = false;

        // this.searchRBCntrl.valueChanges.subscribe((data: any) => {
        //   this.searchedRuleBook = data
        //     ? this.filterData(data, 'RuleBook')
        //     : this.masterFilters.ruleBook;
        // });

        // this.searchPACntrl.valueChanges.subscribe((data: any) => {
        //   this.searchedPart = data
        //     ? this.filterData(data, 'Part')
        //     : this.masterFilters.part;
        // });

        this.searchOWCntrl.valueChanges.subscribe((data: any) => {
          this.searchedOwner = data
            ? this.filterData(data, 'Owner')
            : this.masterFilters.owner;
        });

        // this.searchRRCntrl.valueChanges.subscribe((data: any) => {
        //   this.searchedRegRule = data
        //     ? this.filterData(data, 'RegRule')
        //     : this.masterFilters.regulatoryRuleFullRequirement;
        // });

        this.searchATCntrl.valueChanges.subscribe((data: any) => {
          this.searchedAT = data
            ? this.filterData(data, 'AssessmentTeam')
            : this.masterFilters.assessmentTeam;
        });

        // this.searchADCntrl.valueChanges.subscribe((data: any) => {
        //   this.searchedAD = data
        //     ? this.filterData(data, 'AssessmentDetails')
        //     : this.masterFilters.assessmentDetails;
        // });

        this.searchASCntrl.valueChanges.subscribe((data: any) => {
          this.searchedAS = data
            ? this.filterData(data, 'AssessmentStatus')
            : this.masterFilters.assessmentStatus;
        });

        this.searchRTCntrl.valueChanges.subscribe((data: any) => {
          this.searchedRT = data
            ? this.filterData(data, 'ReviewTeam')
            : this.masterFilters.reviewTeam;
        });

        // this.searchRDCntrl.valueChanges.subscribe((data: any) => {
        //   this.searchedRD = data
        //     ? this.filterData(data, 'ReviewDetails')
        //     : this.masterFilters.reviewDetails;
        // });

        this.searchRSCntrl.valueChanges.subscribe((data: any) => {
          this.searchedRS = data
            ? this.filterData(data, 'ReviewStatus')
            : this.masterFilters.reviewStatus;
        });

        this.searchOSCntrl.valueChanges.subscribe((data: any) => {
          this.searchedOS = data
            ? this.filterData(data, 'OverallStatus')
            : this.masterFilters.overallStatus;
        });

        this.searchRCCntrl.valueChanges.subscribe((data: any) => {
          this.searchedRC = data
            ? this.filterData(data, 'RuleConclusion')
            : this.masterFilters.ruleConclusion;
        });

        // this.searchOCCntrl.valueChanges.subscribe((data: any) => {
        //   this.searchedOC = data
        //     ? this.filterData(data, 'OverallConclusion')
        //     : this.masterFilters.overallConclusion;
        // });

        this.searchGTCntrl.valueChanges.subscribe((data: any) => {
          this.searchedGT = data
            ? this.filterData(data, 'GapTeam')
            : this.masterFilters.gapTeam;
        });

        // this.searchGDCntrl.valueChanges.subscribe((data: any) => {
        //   this.searchedGD = data
        //     ? this.filterData(data, 'GapDetails')
        //     : this.masterFilters.gapDetails;
        // });

        this.searchGSCntrl.valueChanges.subscribe((data: any) => {
          this.searchedGS = data
            ? this.filterData(data, 'GapStatus')
            : this.masterFilters.gapStatus;
        });

        this.searchETCntrl.valueChanges.subscribe((data: any) => {
          this.searchedET = data
            ? this.filterData(data, 'EnhancementTeam')
            : this.masterFilters.enhancementTeam;
        });

        // this.searchEDCntrl.valueChanges.subscribe((data: any) => {
        //   this.searchedED = data
        //     ? this.filterData(data, 'EnhancementDetails')
        //     : this.masterFilters.enhancementDetails;
        // });

        this.searchESCntrl.valueChanges.subscribe((data: any) => {
          this.searchedES = data
            ? this.filterData(data, 'EnhancementStatus')
            : this.masterFilters.enhancementStatus;
        });
      });
  }

  filterData(search: string, filter: string): any {
    switch (filter) {
      // case 'RuleBook':
      //   return this.searchedRuleBook.filter((option) =>
      //     option.name.toLowerCase().includes(search.toLowerCase())
      //   );
      //   break;
      // case 'Part':
      //   return this.searchedPart.filter((option) =>
      //     option.name.toLowerCase().includes(search.toLowerCase())
      //   );
      //   break;
      case 'Owner':
        return this.searchedOwner.filter((option) =>
          option.name.toLowerCase().includes(search.toLowerCase())
        );
        break;
      // case 'RegulationRule':
      //   return this.searchedRegRule.filter((option) =>
      //     option.name.toLowerCase().includes(search.toLowerCase())
      //   );
      //   break;
      case 'AssessmentTeam':
        return this.searchedAT.filter((option) =>
          option.name.toLowerCase().includes(search.toLowerCase())
        );
        break;
      // case 'AssessmentDetails':
      //   return this.searchedAD.filter((option) =>
      //     option.name.toLowerCase().includes(search.toLowerCase())
      //   );
      //   break;
      case 'AssessmentStatus':
        return this.searchedAS.filter((option) =>
          option.name.toLowerCase().includes(search.toLowerCase())
        );
        break;
      case 'ReviewTeam':
        return this.searchedRT.filter((option) =>
          option.name.toLowerCase().includes(search.toLowerCase())
        );
        break;
      // case 'ReviewDetails':
      //   return this.searchedRD.filter((option) =>
      //     option.name.toLowerCase().includes(search.toLowerCase())
      //   );
      //   break;
      case 'ReviewStatus':
        return this.searchedRS.filter((option) =>
          option.name.toLowerCase().includes(search.toLowerCase())
        );
        break;
      case 'OverallStatus':
        return this.searchedOS.filter((option) =>
          option.name.toLowerCase().includes(search.toLowerCase())
        );
        break;
      case 'RuleConclusion':
        return this.searchedRC.filter((option) =>
          option.name.toLowerCase().includes(search.toLowerCase())
        );
        break;
      // case 'OverallConclusion':
      //   return this.searchedOC.filter((option) =>
      //     option.name.toLowerCase().includes(search.toLowerCase())
      //   );
      //   break;
      case 'GapTeam':
        return this.searchedGT.filter((option) =>
          option.name.toLowerCase().includes(search.toLowerCase())
        );
        break;
      // case 'GapDetails':
      //   return this.searchedGD.filter((option) =>
      //     option.name.toLowerCase().includes(search.toLowerCase())
      //   );
      //   break;
      case 'GapStatus':
        return this.searchedGS.filter((option) =>
          option.name.toLowerCase().includes(search.toLowerCase())
        );
        break;
      case 'EnhancementTeam':
        return this.searchedET.filter((option) =>
          option.name.toLowerCase().includes(search.toLowerCase())
        );
        break;
      // case 'EnhancementDetails':
      //   return this.searchedED.filter((option) =>
      //     option.name.toLowerCase().includes(search.toLowerCase())
      //   );
      //   break;
      case 'EnhancementStatus':
        return this.searchedES.filter((option) =>
          option.name.toLowerCase().includes(search.toLowerCase())
        );
        break;
      default:
        return new Array<FilterViewModel>();
        break;
    }
  }

  saveOnBrowser(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  fetchFromBrowser(key: string): any {
    return localStorage.getItem(key);
  }

  TriggerAction(): void {
    this.selfAssessmentFilter.fromDate = this.datePipe.transform(this.selfAssessmentFilter.fromDate, "yyyy-MM-dd")!;
    this.selfAssessmentFilter.toDate = this.datePipe.transform(this.selfAssessmentFilter.toDate, "yyyy-MM-dd")!;
    this.selfAssessmentFilter = MasterHelper.parseSelfAssessmentFilters(
      this.selfAssessmentFilter
    ) as SelfAssessmentFilter;
    this.saveOnBrowser(
      this.filterPersistenceKey,
      JSON.stringify(this.selfAssessmentFilter)
    );
    this.OnFilter.emit(this.selfAssessmentFilter);
  }
  // Rule Book events
  addRB(event: MatChipInputEvent): void {
    const value = event.value;
    let filterResult = this.selfAssessmentFilter.ruleBook?.filter((option: string) => option.trim() == value.trim());
    if (filterResult && filterResult.length > 0) {
      event.chipInput!.clear();
      return;
    }
    if ((value || '').trim()) {
      this.selfAssessmentFilter.ruleBook.push(value.trim());
    }
    event.chipInput!.clear();
  }

  removeRB(status: string): void {
    const index = this.selfAssessmentFilter.ruleBook.indexOf(status);

    if (index >= 0) {
      this.selfAssessmentFilter.ruleBook.splice(index, 1);
    }
  }
  //Part Events
  addPA(event: MatChipInputEvent): void {
    const value = event.value;
    let filterResult = this.selfAssessmentFilter.part?.filter((option: string) => option.trim() == value.trim());
    if (filterResult && filterResult.length > 0) {
      event.chipInput!.clear();
      return;
    }
    if ((value || '').trim()) {
      this.selfAssessmentFilter.part.push(value.trim());
    }
    event.chipInput!.clear();
  }

  removePA(status: string): void {
    const index = this.selfAssessmentFilter.part.indexOf(status);

    if (index >= 0) {
      this.selfAssessmentFilter.part.splice(index, 1);
    }
  }
  // Owner Events
  addOW(event: MatChipInputEvent): void {
    if (!this.oWAutocomplete.isOpen) {
      const value = event.value;
      // if ((value || '').trim()) {
      //   let sameValueRow = this.assessorDD.filter((obj) => obj === value);
      //   if (sameValueRow.length == 0) {
      //     (this.assessorDD as string[]).push(value);
      //   }
      // }

      if ((value || '').trim()) {
        let sameValueRow = this.selfAssessmentFilter.owner.filter((obj) => obj === value);
        if (sameValueRow.length == 0) {
          (this.selfAssessmentFilter.owner as string[]).push(value);
        }
      }

      event.chipInput!.clear();
      this.searchOWCntrl.setValue(null);
    }
  }

  selectedOWEvent(event: MatAutocompleteSelectedEvent): void {
    let filterRow = this.selfAssessmentFilter.owner.filter((obj) => obj === event.option.viewValue);
    if (filterRow.length == 0) {
      if (this.selfAssessmentFilter.owner) {
        this.selfAssessmentFilter.owner.push(event.option.viewValue);
      } else {
        this.selfAssessmentFilter.owner = [];
        this.selfAssessmentFilter.owner.push(event.option.viewValue);
      }
    }
    this.oWInput.nativeElement.value = '';
    this.searchOWCntrl.setValue(null);
    this.searchOWCntrl.disable();
    this.searchOWCntrl.enable();
  }

  removeOW(status: string): void {
    const index = (this.selfAssessmentFilter.owner as string[]).indexOf(
      status
    );

    if (index >= 0) {
      (this.selfAssessmentFilter.owner as string[]).splice(index, 1);
    }
  }
  // Rule Regulator Events
  addRR(event: MatChipInputEvent): void {
    const value = event.value;
    let filterResult = this.selfAssessmentFilter.regulatoryRuleFullRequirement?.filter((option: string) => option.trim() == value.trim());
    if (filterResult && filterResult.length > 0) {
      event.chipInput!.clear();
      return;
    }
    if ((value || '').trim()) {
      this.selfAssessmentFilter.regulatoryRuleFullRequirement.push(value.trim());
    }
    event.chipInput!.clear();
  }

  removeRR(status: string): void {
    const index = this.selfAssessmentFilter.regulatoryRuleFullRequirement.indexOf(status);

    if (index >= 0) {
      this.selfAssessmentFilter.regulatoryRuleFullRequirement.splice(index, 1);
    }
  }
  // Assessment Team Events
  addAT(event: MatChipInputEvent): void {
    if (!this.aTAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        (this.selfAssessmentFilter.assessmentTeam as string[]).push(value);
      }

      event.chipInput!.clear();
      this.searchATCntrl.setValue(null);
    }
  }

  selectedATEvent(event: MatAutocompleteSelectedEvent): void {
    let filterResult = this.selfAssessmentFilter.assessmentTeam?.filter((option: string) => option.trim() == event.option.viewValue.trim());
    if (filterResult && filterResult.length == 0) {
      if (this.selfAssessmentFilter.assessmentTeam) {
        this.selfAssessmentFilter.assessmentTeam.push(event.option.viewValue);
      } else {
        this.selfAssessmentFilter.assessmentTeam = [];
        this.selfAssessmentFilter.assessmentTeam.push(event.option.viewValue);
      }
    }

    this.aTInput.nativeElement.value = '';
    this.searchATCntrl.setValue(null);
    this.searchATCntrl.disable();
    this.searchATCntrl.enable();
  }

  removeAT(status: string): void {
    const index = (
      this.selfAssessmentFilter.assessmentTeam as string[]
    ).indexOf(status);

    if (index >= 0) {
      (this.selfAssessmentFilter.assessmentTeam as string[]).splice(index, 1);
    }
  }
  // Assessment Details Events
  addAD(event: MatChipInputEvent): void {
    const value = event.value;
    let filterResult = this.selfAssessmentFilter.assessmentDetails?.filter((option: string) => option.trim() == value.trim());
    if (filterResult && filterResult.length > 0) {
      event.chipInput!.clear();
      return;
    }
    if ((value || '').trim()) {
      this.selfAssessmentFilter.assessmentDetails.push(value.trim());
    }
    event.chipInput!.clear();
  }

  removeAD(status: string): void {
    const index = this.selfAssessmentFilter.assessmentDetails.indexOf(status);

    if (index >= 0) {
      this.selfAssessmentFilter.assessmentDetails.splice(index, 1);
    }
  }
  // Assessment Status Events
  addAS(event: MatChipInputEvent): void {
    if (!this.aSAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        (this.selfAssessmentFilter.assessmentStatus as string[]).push(value);
      }

      event.chipInput!.clear();
      this.searchASCntrl.setValue(null);
    }
  }

  selectedASEvent(event: MatAutocompleteSelectedEvent): void {
    let filterRow = this.selfAssessmentFilter.assessmentStatus.filter((obj) => obj === event.option.viewValue);
    if (filterRow.length == 0) {
      if (this.selfAssessmentFilter.assessmentStatus) {
        this.selfAssessmentFilter.assessmentStatus.push(event.option.viewValue);
      } else {
        this.selfAssessmentFilter.assessmentStatus = [];
        this.selfAssessmentFilter.assessmentStatus.push(event.option.viewValue);
      }
    }

    this.aSInput.nativeElement.value = '';
    this.searchASCntrl.setValue(null);
    this.searchASCntrl.disable();
    this.searchASCntrl.enable();
  }

  removeAS(status: string): void {
    const index = (
      this.selfAssessmentFilter.assessmentStatus as string[]
    ).indexOf(status);

    if (index >= 0) {
      (this.selfAssessmentFilter.assessmentStatus as string[]).splice(index, 1);
    }
  }
  // Review Team Events
  addRT(event: MatChipInputEvent): void {
    if (!this.rTAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        (this.selfAssessmentFilter.reviewTeam as string[]).push(value);
      }

      event.chipInput!.clear();
      this.searchRTCntrl.setValue(null);
    }
  }

  selectedRTEvent(event: MatAutocompleteSelectedEvent): void {
    let filterRow = this.selfAssessmentFilter.reviewTeam.filter((obj) => obj === event.option.viewValue);
    if (filterRow.length == 0) {
      if (this.selfAssessmentFilter.reviewTeam) {
        this.selfAssessmentFilter.reviewTeam.push(event.option.viewValue);
      } else {
        this.selfAssessmentFilter.reviewTeam = [];
        this.selfAssessmentFilter.reviewTeam.push(event.option.viewValue);
      }
    }
    this.rTInput.nativeElement.value = '';
    this.searchRTCntrl.setValue(null);
    this.searchRTCntrl.disable();
    this.searchRTCntrl.enable();
  }

  removeRT(status: string): void {
    const index = (this.selfAssessmentFilter.reviewTeam as string[]).indexOf(
      status
    );

    if (index >= 0) {
      (this.selfAssessmentFilter.reviewTeam as string[]).splice(index, 1);
    }
  }
  // Review Details Events
  addRD(event: MatChipInputEvent): void {
    const value = event.value;
    let filterResult = this.selfAssessmentFilter.reviewDetails?.filter((option: string) => option.trim() == value.trim());
    if (filterResult && filterResult.length > 0) {
      event.chipInput!.clear();
      return;
    }
    if ((value || '').trim()) {
      this.selfAssessmentFilter.reviewDetails.push(value.trim());
    }
    event.chipInput!.clear();
  }

  removeRD(status: string): void {
    const index = this.selfAssessmentFilter.reviewDetails.indexOf(status);

    if (index >= 0) {
      this.selfAssessmentFilter.reviewDetails.splice(index, 1);
    }
  }
  // Review Status Events
  addRS(event: MatChipInputEvent): void {
    if (!this.rSAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        (this.selfAssessmentFilter.reviewStatus as string[]).push(value);
      }

      event.chipInput!.clear();
      this.searchRSCntrl.setValue(null);
    }
  }

  selectedRSEvent(event: MatAutocompleteSelectedEvent): void {
    let filterRow = this.selfAssessmentFilter.reviewStatus.filter((obj) => obj === event.option.viewValue);
    if (filterRow.length == 0) {
      if (this.selfAssessmentFilter.reviewStatus) {
        this.selfAssessmentFilter.reviewStatus.push(event.option.viewValue);
      } else {
        this.selfAssessmentFilter.reviewStatus = [];
        this.selfAssessmentFilter.reviewStatus.push(event.option.viewValue);
      }
    }
    this.rSInput.nativeElement.value = '';
    this.searchRSCntrl.setValue(null);
    this.searchRSCntrl.disable();
    this.searchRSCntrl.enable();
  }

  removeRS(status: string): void {
    const index = (this.selfAssessmentFilter.reviewStatus as string[]).indexOf(
      status
    );

    if (index >= 0) {
      (this.selfAssessmentFilter.reviewStatus as string[]).splice(index, 1);
    }
  }
  // Overall Status Events
  addOS(event: MatChipInputEvent): void {
    if (!this.oSAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        (this.selfAssessmentFilter.overallStatus as string[]).push(value);
      }

      event.chipInput!.clear();
      this.searchOSCntrl.setValue(null);
    }
  }

  selectedOSEvent(event: MatAutocompleteSelectedEvent): void {
    let filterRow = this.selfAssessmentFilter.overallStatus.filter((obj) => obj === event.option.viewValue);
    if (filterRow.length == 0) {
      if (this.selfAssessmentFilter.overallStatus) {
        this.selfAssessmentFilter.overallStatus.push(event.option.viewValue);
      } else {
        this.selfAssessmentFilter.overallStatus = [];
        this.selfAssessmentFilter.overallStatus.push(event.option.viewValue);
      }
    }
    this.oSInput.nativeElement.value = '';
    this.searchOSCntrl.setValue(null);
    this.searchOSCntrl.disable();
    this.searchOSCntrl.enable();
  }

  removeOS(status: string): void {
    const index = (this.selfAssessmentFilter.overallStatus as string[]).indexOf(
      status
    );

    if (index >= 0) {
      (this.selfAssessmentFilter.overallStatus as string[]).splice(index, 1);
    }
  }
  //Rule Conclusion Events
  addRC(event: MatChipInputEvent): void {
    if (!this.rCAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        (this.selfAssessmentFilter.ruleConclusion as string[]).push(value);
      }

      event.chipInput!.clear();
      this.searchRCCntrl.setValue(null);
    }
  }

  selectedRCEvent(event: MatAutocompleteSelectedEvent): void {
    let filterRow = this.selfAssessmentFilter.ruleConclusion.filter((obj) => obj === event.option.viewValue);
    if (filterRow.length == 0) {
      if (this.selfAssessmentFilter.ruleConclusion) {
        this.selfAssessmentFilter.ruleConclusion.push(event.option.viewValue);
      } else {
        this.selfAssessmentFilter.ruleConclusion = [];
        this.selfAssessmentFilter.ruleConclusion.push(event.option.viewValue);
      }
    }
    this.rCInput.nativeElement.value = '';
    this.searchRCCntrl.setValue(null);
    this.searchRCCntrl.disable();
    this.searchRCCntrl.enable();
  }

  removeRC(status: string): void {
    const index = (
      this.selfAssessmentFilter.ruleConclusion as string[]
    ).indexOf(status);

    if (index >= 0) {
      (this.selfAssessmentFilter.ruleConclusion as string[]).splice(index, 1);
    }
  }
  //Overall Conclusion Events
  addOC(event: MatChipInputEvent): void {
    const value = event.value;
    let filterResult = this.selfAssessmentFilter.overallConclusion?.filter((option: string) => option.trim() == value.trim());
    if (filterResult && filterResult.length > 0) {
      event.chipInput!.clear();
      return;
    }
    if ((value || '').trim()) {
      this.selfAssessmentFilter.overallConclusion.push(value.trim());
    }
    event.chipInput!.clear();
  }

  removeOC(status: string): void {
    const index = this.selfAssessmentFilter.overallConclusion.indexOf(status);

    if (index >= 0) {
      this.selfAssessmentFilter.overallConclusion.splice(index, 1);
    }
  }
  // Gap Team Events
  addGT(event: MatChipInputEvent): void {
    if (!this.gTAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        (this.selfAssessmentFilter.gapTeam as string[]).push(value);
      }

      event.chipInput!.clear();
      this.searchGTCntrl.setValue(null);
    }
  }

  selectedGTEvent(event: MatAutocompleteSelectedEvent): void {
    let filterRow = this.selfAssessmentFilter.gapTeam.filter((obj) => obj === event.option.viewValue);
    if (filterRow.length == 0) {
      if (this.selfAssessmentFilter.gapTeam) {
        this.selfAssessmentFilter.gapTeam.push(event.option.viewValue);
      } else {
        this.selfAssessmentFilter.gapTeam = [];
        this.selfAssessmentFilter.gapTeam.push(event.option.viewValue);
      }
    }
    this.gTInput.nativeElement.value = '';
    this.searchGTCntrl.setValue(null);
    this.searchGTCntrl.disable();
    this.searchGTCntrl.enable();
  }

  removeGT(status: string): void {
    const index = (this.selfAssessmentFilter.gapTeam as string[]).indexOf(
      status
    );

    if (index >= 0) {
      (this.selfAssessmentFilter.gapTeam as string[]).splice(index, 1);
    }
  }
  // Gap Details Events
  addGD(event: MatChipInputEvent): void {
    const value = event.value;
    let filterResult = this.selfAssessmentFilter.gapDetails?.filter((option: string) => option.trim() == value.trim());
    if (filterResult && filterResult.length > 0) {
      event.chipInput!.clear();
      return;
    }
    if ((value || '').trim()) {
      this.selfAssessmentFilter.gapDetails.push(value.trim());
    }
    event.chipInput!.clear();
  }

  removeGD(status: string): void {
    const index = this.selfAssessmentFilter.gapDetails.indexOf(status);

    if (index >= 0) {
      this.selfAssessmentFilter.gapDetails.splice(index, 1);
    }
  }

  // Gap Status Events
  addGS(event: MatChipInputEvent): void {
    if (!this.gSAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        (this.selfAssessmentFilter.gapStatus as string[]).push(value);
      }

      event.chipInput!.clear();
      this.searchGSCntrl.setValue(null);
    }
  }

  selectedGSEvent(event: MatAutocompleteSelectedEvent): void {
    let filterRow = this.selfAssessmentFilter.gapStatus.filter((obj) => obj === event.option.viewValue);
    if (filterRow.length == 0) {
      if (this.selfAssessmentFilter.gapStatus) {
        this.selfAssessmentFilter.gapStatus.push(event.option.viewValue);
      } else {
        this.selfAssessmentFilter.gapStatus = [];
        this.selfAssessmentFilter.gapStatus.push(event.option.viewValue);
      }
    }
    this.gSInput.nativeElement.value = '';
    this.searchGSCntrl.setValue(null);
    this.searchGSCntrl.disable();
    this.searchGSCntrl.enable();
  }

  removeGS(status: string): void {
    const index = (
      this.selfAssessmentFilter.gapStatus as string[]
    ).indexOf(status);

    if (index >= 0) {
      (this.selfAssessmentFilter.gapStatus as string[]).splice(
        index,
        1
      );
    }
  }
  // Enhancement Team Events
  addET(event: MatChipInputEvent): void {
    if (!this.eTAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        (this.selfAssessmentFilter.enhancementTeam as string[]).push(value);
      }

      event.chipInput!.clear();
      this.searchETCntrl.setValue(null);
    }
  }

  selectedETEvent(event: MatAutocompleteSelectedEvent): void {
    let filterRow = this.selfAssessmentFilter.enhancementTeam.filter((obj) => obj === event.option.viewValue);
    if (filterRow.length == 0) {
      if (this.selfAssessmentFilter.enhancementTeam) {
        this.selfAssessmentFilter.enhancementTeam.push(event.option.viewValue);
      } else {
        this.selfAssessmentFilter.enhancementTeam = [];
        this.selfAssessmentFilter.enhancementTeam.push(event.option.viewValue);
      }
    }

    this.eTInput.nativeElement.value = '';
    this.searchETCntrl.setValue(null);
    this.searchETCntrl.disable();
    this.searchETCntrl.enable();
  }

  removeET(status: string): void {
    const index = (
      this.selfAssessmentFilter.enhancementTeam as string[]
    ).indexOf(status);

    if (index >= 0) {
      (this.selfAssessmentFilter.enhancementTeam as string[]).splice(index, 1);
    }
  }
  // Enhancement Details Events
  addED(event: MatChipInputEvent): void {
    const value = event.value;
    let filterResult = this.selfAssessmentFilter.enhancementDetails?.filter((option: string) => option.trim() == value.trim());
    if (filterResult && filterResult.length > 0) {
      event.chipInput!.clear();
      return;
    }
    if ((value || '').trim()) {
      this.selfAssessmentFilter.enhancementDetails.push(value.trim());
    }
    event.chipInput!.clear();
  }

  removeED(title: string): void {
    const index = this.selfAssessmentFilter.enhancementDetails.indexOf(title);

    if (index >= 0) {
      this.selfAssessmentFilter.enhancementDetails.splice(index, 1);
    }
  }
  // addED(event: MatChipInputEvent): void {
  //   if (!this.eDAutocomplete.isOpen) {
  //     const value = event.value;

  //     if ((value || '').trim()) {
  //       (this.selfAssessmentFilter.enhancementDetails as string[]).push(value);
  //     }

  //     event.chipInput!.clear();
  //     this.searchEDCntrl.setValue(null);
  //   }
  // }

  // selectedEDEvent(event: MatAutocompleteSelectedEvent): void {
  //   if (this.selfAssessmentFilter.enhancementDetails) {
  //     this.selfAssessmentFilter.enhancementDetails.push(event.option.viewValue);
  //   } else {
  //     this.selfAssessmentFilter.enhancementDetails = [];
  //     this.selfAssessmentFilter.enhancementDetails.push(event.option.viewValue);
  //   }
  //   this.eDInput.nativeElement.value = '';
  //   this.searchEDCntrl.setValue(null);
  //   this.searchEDCntrl.disable();
  //   this.searchEDCntrl.enable();
  // }

  // removeED(status: string): void {
  //   const index = (
  //     this.selfAssessmentFilter.enhancementDetails as string[]
  //   ).indexOf(status);

  //   if (index >= 0) {
  //     (this.selfAssessmentFilter.enhancementDetails as string[]).splice(index, 1);
  //   }
  // }
  // Enhancement Status Events
  addES(event: MatChipInputEvent): void {
    if (!this.eSAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        (this.selfAssessmentFilter.enhancementStatus as string[]).push(value);
      }

      event.chipInput!.clear();
      this.searchESCntrl.setValue(null);
    }
  }

  selectedESEvent(event: MatAutocompleteSelectedEvent): void {
    let filterRow = this.selfAssessmentFilter.enhancementStatus.filter((obj) => obj === event.option.viewValue);
    if (filterRow.length == 0) {
      if (this.selfAssessmentFilter.enhancementStatus) {
        this.selfAssessmentFilter.enhancementStatus.push(event.option.viewValue);
      } else {
        this.selfAssessmentFilter.enhancementStatus = [];
        this.selfAssessmentFilter.enhancementStatus.push(event.option.viewValue);
      }
    }
    this.eSInput.nativeElement.value = '';
    this.searchESCntrl.setValue(null);
    this.searchESCntrl.disable();
    this.searchESCntrl.enable();
  }

  removeES(status: string): void {
    const index = (
      this.selfAssessmentFilter.enhancementStatus as string[]
    ).indexOf(status);

    if (index >= 0) {
      (this.selfAssessmentFilter.enhancementStatus as string[]).splice(index, 1);
    }
  }
  // Keywords events
  add(event: MatChipInputEvent): void {
    if (!this.autoKeyword.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        this.selfAssessmentFilter.searchQuery.push(value.trim());
      }

      event.chipInput!.clear();
      this.keyCtrl.setValue(null);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    if (this.selfAssessmentFilter.searchQuery) {
      this.selfAssessmentFilter.searchQuery.push(event.option.viewValue);
    } else {
      this.selfAssessmentFilter.searchQuery = [];
      this.selfAssessmentFilter.searchQuery.push(event.option.viewValue);
    }
    this.keywordInput.nativeElement.value = '';
    this.keyCtrl.setValue(null);
    this.keyCtrl.disable();
    this.keyCtrl.enable();
  }

  remove(_searchstr: string): void {
    const index = (this.selfAssessmentFilter.searchQuery as string[]).indexOf(
      _searchstr
    );

    if (index >= 0) {
      (this.selfAssessmentFilter.searchQuery as string[]).splice(index, 1);
    }
  }
}
